import { render, staticRenderFns } from "./InsuranceAdminAgentDashboard.vue?vue&type=template&id=299ad0b7&scoped=true"
import script from "./InsuranceAdminAgentDashboard.vue?vue&type=script&lang=js"
export * from "./InsuranceAdminAgentDashboard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceAdminAgentDashboard.vue?vue&type=style&index=0&id=299ad0b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ad0b7",
  null
  
)

export default component.exports